import React from "react";
import { CircularProgress, Box, Typography } from "@mui/material";

const LoadingUI = ({ image = null, text = "Loading..." }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
        py: 4, // padding vertically
      }}
    >
      {image || <CircularProgress color="primary" />}
      <Typography variant="body1" color="text.secondary">
        {text}
      </Typography>
    </Box>
  );
};

export default LoadingUI;